import React from 'react';

import styles from './styles/search-field.module.css';

import {ReactComponent as SearchIcon} from '../../../assets/design-system/search.svg';

export default function SearchField({ width, height, placeholder, name, value, handleChange }) {
    const iconStyle = height === 'H50'
        ? { width: '20px', height: '20px' }
        : { width: '16px', height: '16px' };

    return (
        <div className={styles.wrapper} style={{ width }} data-type={height}>
            <SearchIcon style={{ ...iconStyle, color: 'var(--gray_purple_middle)' }} />
            <input
                placeholder={placeholder}
                name={name}
                value={value}
                onChange={handleChange}
                autoComplete='off'
            />
        </div>
    );
}
